import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { AppConfig } from "../config/app.config";
import { BehaviorSubject, Observable } from "rxjs";
import { AuthService } from "../auth/auth.service";

@Injectable({
    providedIn: 'root'
})
export class QuoteDocumentService {
    private apiUrl = AppConfig.apiUrl;
    authservice = inject(AuthService)       
    private token = this.authservice.getToken()    
    httpClient = inject(HttpClient);
    downloadQuoteDcoument$ = new BehaviorSubject<boolean>(false);
    emailQuoteDcoument$ = new BehaviorSubject<boolean>(false);


    getDownloadQuoteDocument() {
        return this.downloadQuoteDcoument$.asObservable();
    }

    setDownloadQuoteDocument(data: boolean) {
        this.downloadQuoteDcoument$.next(data);
    }

    getEmailQuoteDocument() {
        return this.emailQuoteDcoument$.asObservable();
    }

    setEmailQuoteDocument(data: boolean) {
        this.emailQuoteDcoument$.next(data);
    }


    onDownloadQuoteDocument(quoteId: number, branchId: number, isQuote: string) {
        const path=`/api/QuoteReport/GetQuoteDocumentDetails?QuoteId=${quoteId}&branchId=${branchId}&isQuote=${isQuote}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    downloadPdf(formData : any): Observable<Blob>{
        const path=`/api/DocumentGen/PolicyGeneration`;
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy/GenerateDocument?path=${encodedPath}`, formData,{ responseType: 'blob' });
    }
    
    emailPdf(formData : any){
        const path=`/api/DocumentGen/MailDocGeneration`;
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`, formData);
    }

    UpdateIsDownloadEmailComplete(quoteId: number, userId: number,versionNo:number, isDownloadEmailCompleteFlag:number) {
        const path=`/api/Quote/UpdateIsDownloadEmailComplete?quoteId=${quoteId}&userId=${userId}&versionNo=${versionNo}&isDownloadEmailCompleteFlag=${isDownloadEmailCompleteFlag}`;
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`,{});
    }

    getIsDownloadEmailComplete(quoteId: number, versionNo: number) {
        const path=`/api/Quote/${quoteId}?versionNo=${versionNo}`;
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

}